export default __webpack_public_path__ + "9fa567e0b130c42cc1e0bb423e1d6dd7.png";